module.exports = __webpack_public_path__ + "static/media/Cats Eyes 10_FRANSKA-mixdown.16bc3a3d.mp3";